import { useQuery, useMutation, useQueryClient } from "react-query";
import { webauthnApi } from "../api/webauthnApi";

const KEY = ["webauthn", "my-credentials"];

/** List + rename + remove the caller's own browser credentials. */
export function useMyCredentials() {
  const qc = useQueryClient();

  const list = useQuery(KEY, () => webauthnApi.listCredentials());

  const rename = useMutation(
    ({ id, label }) => webauthnApi.renameCredential(id, label),
    {
      // Optimistic rename per spec §20.9.
      onMutate: async ({ id, label }) => {
        await qc.cancelQueries(KEY);
        const prev = qc.getQueryData(KEY);
        qc.setQueryData(KEY, (old = []) =>
          old.map((c) => (c.id === id ? { ...c, label } : c))
        );
        return { prev };
      },
      onError: (_e, _v, ctx) => ctx && qc.setQueryData(KEY, ctx.prev),
      onSettled: () => qc.invalidateQueries(KEY),
    }
  );

  const remove = useMutation((id) => webauthnApi.removeCredential(id), {
    onSuccess: () => qc.invalidateQueries(KEY),
  });

  return { list, rename, remove };
}
